import LocalizedStrings from 'localized-strings';

export default new LocalizedStrings({
  en: {
    cancel: 'Cancel',
    confirm: 'Yes, mark as paid',
    description: 'Make sure your invoice has been fully paid',
    errorMessage:
      'An error occurred while editing your invoice. Please try again in a few minutes and don’t hesitate to contact us if the error remains.',
    successMessage: 'Your invoice n°{0} has been successfully marked as paid!',
    title: 'Do you really want to mark this invoice as paid?',
  },
  fr: {
    cancel: 'Annuler',
    confirm: 'Oui, marquer comme payée',
    description:
      'Assurez vous que votre facture ait été payée dans sa totalité',
    errorMessage:
      'Une erreur est survenue lors la modification de la facture. Essayez à nouveau dans quelques minutes et n’hésitez pas à nous contacter si le problème persiste.',
    successMessage: 'Votre facture n°{0} a bien été marquée comme payée\xA0!',
    title: 'Voulez-vous vraiment marquer cette facture comme payée\xA0?',
  },
} as const);
